import * as types from './mutation-types'
const mutations = {
  [types.SET_YEAR](state, data) {
    state.year = data
  },
  [types.SET_HANDOUTFILTERS](state, filters) {
    state.handoutFilters = filters
  },
  [types.SET_CATALOG](state, data) {
    state.catalog = data
  },
  [types.SET_CMSTYPES](state, data) {
    state.cmsTypes = data
  },
  [types.SET_TEXTBOOK](state, data) {
    state.textBook = data
  },
  [types.SET_DEFAULTBOOK](state, data) {
    state.defaultbook = data
  },
  [types.SET_BKID](state, data) {
    state.bkId = data
  },
  [types.SET_FORMATS](state, data) {
    state.formats = data
  },
  [types.SET_KPS](state, data) {
    state.kps = data
  },
  [types.SET_SINGLEORMULTI](state, data) {
    state.singleormulti = data
  },
  [types.SET_BOOKORKPS](state, data) {
    state.bookorkps = data
  },
  [types.SET_FACTORS](state, data) {
    state.factors = data
  }
}

export default mutations
